"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpecsFromStore = getSpecsFromStore;
function getSpecsFromStore(specs, chartType, specType) {
    return Object.values(specs).filter((spec) => spec.chartType === chartType && spec.specType === specType);
}
//# sourceMappingURL=get_specs_from_store.js.map